module.exports = __webpack_public_path__ + "img/waving-hand.a3987ead.svg";